import './VideoBanner.css'
import playButtonImage from '../../assets/play_btn.png'
import verrafiedMarkImage from '../../assets/vfied_mark.png'
import defaultVideoThumbnail from '../../assets/video_thumb.png'

interface VideoBannerProps {
  videoThumbnail?: string
  onPlay?: () => void
  showPlayButton?: boolean
}

export default function VideoBanner({ 
  videoThumbnail, 
  onPlay,
  showPlayButton = true
}: VideoBannerProps) {
  // Используем переданное изображение или дефолтное
  const thumbnail = videoThumbnail || defaultVideoThumbnail

  const handlePlay = () => {
    if (onPlay) {
      onPlay()
    }
  }

  return (
    <div className="video-banner">
      <div className="video-banner__container">
        <img 
          src={thumbnail} 
          alt="Video thumbnail" 
          className="video-banner__thumbnail"
        />
        {showPlayButton && (
          <button 
            className="video-banner__play-button"
            onClick={handlePlay}
            aria-label="Play video"
          >
            <img 
              src={playButtonImage} 
              alt="Play" 
              className="video-banner__play-icon"
            />
          </button>
        )}
        <div className="video-banner__mark">
          <img 
            src={verrafiedMarkImage} 
            alt="VERRAFIED AI" 
            className="video-banner__mark-image"
          />
        </div>
      </div>
    </div>
  )
}
